import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/succeed.png'


const _withScopeId = n => (_pushScopeId("data-v-3673aabf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainBody" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "succeedWrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "succeedPhoto"
  }),
  /*#__PURE__*/_createElementVNode("h3", { style: {"margin-top":"20px"} }, "购买成功")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popupTitle" }, "实名认证二维码", -1))
const _hoisted_4 = ["src"]

import {
  getWifiCustomizationCardQueryCardMsg,
  getWifiCustomizationCardRealName,
} from "@/api";
import router from "@/router";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { showDialog } from "vant";
import { shouldRequireRealName } from "@/utils/realNameAccess";


export default /*#__PURE__*/_defineComponent({
  __name: 'purchaseSucceeds',
  setup(__props) {

function onClickLeft() {
  router.back();
}

const route = useRoute();
const iccid = route.query.iccid as string;
const showImage = ref(false);
const imageUrl = ref("");

function checkRealNameRequirement() {
  if (!iccid) return;

  getWifiCustomizationCardQueryCardMsg({ iccid }).then((cardRes: any) => {
    const card = cardRes?.result;
    if (
      cardRes?.code !== 200 ||
      !shouldRequireRealName(card)
    ) return;

    getWifiCustomizationCardRealName({ iccid }).then((realNameRes: any) => {
      const authWay = Number(realNameRes?.result?.authWay);
      const url = realNameRes?.result?.url;
      if (realNameRes?.code !== 200 || !url) return;

      showDialog({
        title: "请完成实名认证",
        message: "套餐购买成功后，请及时完成实名认证。完成认证后，卡片才能正常使用相关服务。",
        showCancelButton: true,
        confirmButtonText: "去实名认证",
        cancelButtonText: "稍后再说",
      }).then(() => {
        if (authWay === 1 || authWay === 5) {
          imageUrl.value = url;
          showImage.value = true;
          return;
        }
        window.location.href = url;
      }).catch(() => {});
    }).catch(() => {});
  }).catch(() => {});
}

onMounted(checkRealNameRequirement);

function toHome() {
  router.push({
    name: "Home",
    params: {
      iccid,
    },
  });
}

return (_ctx: any,_cache: any) => {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "支付成功",
      "left-arrow": "",
      onClickLeft: onClickLeft
    }),
    _hoisted_2,
    _createVNode(_component_van_button, {
      color: "#FF7744",
      block: "",
      onClick: toHome
    }, {
      default: _withCtx(() => [
        _createTextVNode("首页")
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: showImage.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((showImage).value = $event)),
      round: ""
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("img", {
          src: imageUrl.value,
          alt: "实名认证二维码",
          class: "qrImg"
        }, null, 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})